import { createFileRoute } from "@tanstack/react-router";
import PainelLayout from "@/components/admin/PainelLayout";
import { pageHead } from "@/lib/seo";

// Painel interno: renderiza só no navegador (a sessão é do aparelho) e nunca é pré-renderizado. Instalável como app
// no celular da Clara (public/admin/manifest.webmanifest, service worker em public/admin-sw.js).
export const Route = createFileRoute("/admin")({
  ssr: false,
  head: () => {
    const base = pageHead({ title: "Painel | Clara Camille", path: "/admin", noindex: true });
    return {
      ...base,
      meta: [
        ...base.meta,
        // viewport-fit=cover: no iPhone o cabeçalho e a barra de baixo respeitam a câmera e a área do gesto.
        { name: "viewport", content: "width=device-width, initial-scale=1, viewport-fit=cover" },
        { name: "theme-color", content: "#f2f5f4" },
        { name: "apple-mobile-web-app-capable", content: "yes" },
        { name: "mobile-web-app-capable", content: "yes" },
        { name: "apple-mobile-web-app-title", content: "Painel" },
        { name: "apple-mobile-web-app-status-bar-style", content: "default" },
        { name: "format-detection", content: "telephone=no" },
      ],
      links: [
        ...base.links,
        { rel: "manifest", href: "/admin/manifest.webmanifest" },
        { rel: "apple-touch-icon", sizes: "180x180", href: "/admin/icons/apple-touch-icon.png" },
      ],
    };
  },
  component: PainelLayout,
});
